const getStudentDetails = state => state?.studentData?.studentDetails
const getCampuDetails = state => state?.studentData?.campusDetails
const getStudentEditData = state => state?.studentData?.studentEditData
const getStudentResumeData = state => state?.studentData?.studentResumeData

const getCountryList = state => state?.studentData?.countryList
const getStateList = state => state?.studentData?.stateList
const getCityList = state => state?.studentData?.cityList
const getFunctionsList = state => state?.studentData?.functionsList
const getDesignationList = state => state?.studentData?.designationList
const getIndustryList = state => state?.studentData?.industryList
const getDegreeList = state => state?.studentData?.degreeList
const getUniversityList = state => state?.studentData?.universityList
const getListOfSkills = state => state?.studentData?.listOfSkills
const getExtEventData = state => state?.studentData?.extEventData

const selectors = {
  getStudentDetails,
  getCampuDetails,
  getStudentEditData,
  getStudentResumeData,
  getCountryList,
  getStateList,
  getCityList,
  getFunctionsList,
  getDesignationList,
  getIndustryList,
  getDegreeList,
  getUniversityList,
  getListOfSkills,
  getExtEventData,
}

export default selectors
